module.exports = __webpack_public_path__ + "static/media/checkWithinCircle.0f8c52c9.svg";